import { t } from '@/hooks/useI18n';

export * from './theme';

// 小程序默认导航配置
export const _DEFAULT_NAV = {
  name: t('card.nav'),
  content: [
    {
      id: 0,
      name: '名片',
      nameEn: 'Card',
      url: 'https://resource.aijiatui.com/min-apps/image-zs/start/e1.png',
      activeUrl: 'https://resource.aijiatui.com/min-apps/image-zs/start/e_a_1.png',
      enable: true
    },
    {
      id: 1,
      name: '产品',
      nameEn: 'Product',
      url: 'https://resource.aijiatui.com/min-apps/image-zs/start/e2.png',
      activeUrl: 'https://resource.aijiatui.com/min-apps/image-zs/start/e_a_2.png',
      enable: true
    },
    {
      id: 2,
      name: '官网',
      nameEn: 'Website',
      url: 'https://resource.aijiatui.com/min-apps/image-zs/start/e3.png',
      activeUrl: 'https://resource.aijiatui.com/min-apps/image-zs/start/e_a_3.png',
      enable: true
    },
    {
      id: 3,
      name: '-',
      nameEn: '-',
      url: 'https://resource.aijiatui.com/min-apps/image-zs/start/e4.png',
      activeUrl: 'https://resource.aijiatui.com/min-apps/image-zs/start/e_a_4.png',
      enable: false
    }
  ]
};
